module.exports = __webpack_public_path__ + "static/media/lucky_number_animals.9ff3cffc.png";